// homesSlice.js
import {
  createSlice,
  createAsyncThunk,
  createSelector,
  //createEntityAdapter
} from '@reduxjs/toolkit';
import sub from 'date-fns/sub';
import axios from 'axios';


/* global process */
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const FEATURE_URL = `${API_BASE_URL}/api/v1/homes`;
const MAIN_HOMES_URL = `${API_BASE_URL}/api/v1/homes/`;
const PILAR1_HOMES_URL = `${API_BASE_URL}/api/v1/homes/`;
const PILAR2_HOMES_URL = `${API_BASE_URL}/api/v1/homes/`;
const PILAR3_HOMES_URL = `${API_BASE_URL}/api/v1/homes/`;
const ANNOUNCES_HOMES_URL = `${API_BASE_URL}/api/v1/homes/`;

/* 
  ADD IMPORTS
  ADD URL
  ADD INITIAL STATE HERE
    - initial states are defined for all the paths (
        fetchMainHomes, 
        fetchPilar1Homes, 
        fetchPilar2Homes, 
        fetchPilar3Homes, 
        fetchAnnouncesHomes
    )
  THEN ADD FUNCTIONS
  THEN DEFINE SLICE
  THEN ADD REDUCERS ACTIONS
  AND THEN ADD THE CASES IN THE extraReducers
  AND THEN ADD SELECTORS
  AND EXPORT REDUCER
*/

const initialState =  {
  //main table
  homes: [],
  //custom
  mainHomes: [],
  pilar1Homes: [],
  pilar2Homes: [],
  pilar3Homes: [],
  announcesHomes: [],
  // isLoading and error with null value
  isLoading: false,
  error: null,
};
//const initialState = [];


/* 
  ADD IMPORTS
  ADD URL
  ADD INITIAL STATE
  ADD FUNCTIONS HERE
    - only Fetchers are defined for CUSTOM urls (
        fetchMainHomes, 
        fetchPilar1Homes, 
        fetchPilar2Homes, 
        fetchPilar3Homes, 
        fetchAnnouncesHomes
    )
  THEN DEFINE SLICE
  THEN ADD REDUCERS ACTIONS
  AND THEN ADD THE CASES IN THE extraReducers
  AND THEN ADD SELECTORS
  AND EXPORT REDUCER
*/

  //CRUD READ FUNCTIONS
  export const fetchHomes = createAsyncThunk('homes/fetchHomes', async() => {
    try {
      const response = await axios.get(FEATURE_URL);
      console.log(response.data);
      return [...response.data];
    } catch (err) {
      return err.message;
    }
  })

  
  export const fetchMainHomes = createAsyncThunk('homes/fetchMainHomes', async() => {
    try {
      const response = await axios.get(MAIN_HOMES_URL);
      console.log('mainHomes', response.data);
      return [...response.data];
    } catch (err) {
      return err.message;
    }
  })

  export const fetchPilar1Homes = createAsyncThunk('homes/fetchPilar1Homes', async() => {
    try {
      const response = await axios.get(PILAR1_HOMES_URL); //PILAR1_HOMES_URL
      console.log('pilar 1', response.data);
      return [...response.data];
    } catch (err) {
      return err.message;
    }
  })

  export const fetchPilar2Homes = createAsyncThunk('homes/fetchPilar2Homes', async() => {
    try {
      const response = await axios.get(PILAR2_HOMES_URL);
      console.log('pilar 2', response.data);
      return [...response.data];
    } catch (err) {
      return err.message;
    }
  })

  export const fetchPilar3Homes = createAsyncThunk('homes/fetchPilar3Homes', async() => {
    try {
      const response = await axios.get(PILAR3_HOMES_URL);
      console.log('pilar 3', response.data);
      return [...response.data];
    } catch (err) {
      return err.message;
    }
  })

  export const fetchAnnouncesHomes = createAsyncThunk('homes/fetchAnnouncesHomes', async() => {
    try {
      const response = await axios.get(ANNOUNCES_HOMES_URL);
      console.log('Announces', response.data);
      return [...response.data];
    } catch (err) {
      return err.message;
    }
  })



  //CRUD CREATE FUNCTION
  export const addNewHome = createAsyncThunk('homes/addNewHome', async(initialHome) => {
    try {
      const response = await axios.post(FEATURE_URL, initialHome);
      return response.data;
    } catch (err) {
      return err.message;
    }
  })
  
  //CRUD UPDATE FUNCTION
  export const updateHome = createAsyncThunk('homes/updateHome', async(initialHome) => {
    const { id } = initialHome;
    try {
      const response = await axios.put(`${FEATURE_URL}/${id}`, initialHome);
      return response.data;
    } catch (err) {
      //return err.message;
      return initialHome;
    }
  })
  
  //CRUD DELETE FUNCTION
  export const deleteHome = createAsyncThunk('homes/deleteHome', async(initialHome) => {
    const { id } = initialHome;
    try {
      const response = await axios.delete(`${FEATURE_URL}/${id}`, initialHome);
      if(response?.status === 200) return initialHome;
      return `${response?.status} : ${response?.statusText}`;
    } catch (err) {
      return err.message;
    }
  })
  //End of functions

/* 
  ADD IMPORTS
  ADD URL
  ADD INITIAL STATE
  ADD FUNCTIONS HERE
  THEN DEFINE SLICE
    - create the feature's Slice with content:
      name (only the main table)
      initialState
      reducers
      extra reducers
  
  THEN ADD REDUCERS ACTIONS
    - Examples 
      if date has special output
      if reactions have to be added (from the insertion) CHECK RELATION WITH OTHER TABLES

  AND THEN ADD THE CASES IN THE extraReducers
    - Add main table extra reducers actions
      fetch
      all other CRUD actions
  AND THEN ADD SELECTORS
  AND EXPORT REDUCER
*/


const homesSlice = createSlice({
  name: 'homes',
  initialState,
  reducers: {
    // ...other reducer actions specific to the home slice
    /* setHomes: (state, action) => {
      state.homes = action.payload;
      console.log(state.homes);
      state.status = 'succeeded';
    }, */
  },
  extraReducers: (builder) => {
    builder
    
    //for main table first
     .addCase(fetchHomes.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(fetchHomes.fulfilled, (state, action) => {
        if(typeof action.payload === 'string') {
          console.log(action.payload)
        }else if(typeof action.payload === 'object'){
          state.status = 'succeeded'
          //adding date and reactions
          let min = 1;
          const loadedHomes = action.payload.map(home => {
            home.date = sub(new Date(), { minutes: min++ }).toISOString();
            /* home.reactions = {
              thumbsUp: 0,
              wow: 0,
              heart: 0,
              rocket: 0,
              coffee: 0
            } */
            return home;
          })
        state.homes = state.homes.concat(loadedHomes);
        }
      })
      .addCase(fetchHomes.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(addNewHome.fulfilled, (state, action) => {
        action.payload.userId = Number(action.payload.userId);
        action.payload.date = new Date().toISOString();
        /* action.payload.reactions = {
          thumbsUp: 0,
          wow: 0,
          heart: 0,
          rocket: 0,
          coffee: 0
        } */
        console.log(action.payload);
        state.homes.push(action.payload);
      })
      .addCase(updateHome.fulfilled, (state, action) => {
        if(!action.payload?.id){
          console.log('Update could not be completed');
          console.log(action.payload);
          return;
        }

        //destructure the id from the action.payload
        const { id } = action.payload;
        action.payload.date = new Date().toISOString();
        const homes = state.homes.filter(home => home.id !== id);
        state.homes = [...homes, action.payload];
      })
      .addCase(deleteHome.fulfilled, (state, action) => {
        if(!action.payload?.id){
          console.log('Delete could not be completed');
          console.log(action.payload);
          return;
        }

        //destructure the id from the action.payload
        const { id } = action.payload;
        const homes = state.homes.filter(home => home.id !== id);
        state.homes = homes;
      })

      //FOR CUSTOM URLS HERE
      .addCase(fetchMainHomes.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchMainHomes.fulfilled, (state, action) => {
        if(typeof action.payload === 'string') {
          console.log(action.payload)
        }else if(typeof action.payload === 'object'){
          state.isLoading = false;
          state.mainHomes = action.payload;
        }
      })
      .addCase(fetchMainHomes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })


      .addCase(fetchPilar1Homes.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPilar1Homes.fulfilled, (state, action) => {
        if(typeof action.payload === 'string') {
          console.log(action.payload)
        }else if(typeof action.payload === 'object'){
          state.isLoading = false;
          state.pilar1Homes = action.payload;
        }
      })
      .addCase(fetchPilar1Homes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })


      .addCase(fetchPilar2Homes.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPilar2Homes.fulfilled, (state, action) => {
        if(typeof action.payload === 'string') {
          console.log(action.payload)
        }else if(typeof action.payload === 'object'){
          state.isLoading = false;
          state.pilar2Homes = action.payload;
        }
      })
      .addCase(fetchPilar2Homes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })


      .addCase(fetchPilar3Homes.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPilar3Homes.fulfilled, (state, action) => {
        if(typeof action.payload === 'string') {
          console.log(action.payload)
        }else if(typeof action.payload === 'object'){
          state.isLoading = false;
          state.pilar3Homes = action.payload;
        }
      })
      .addCase(fetchPilar3Homes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })


      .addCase(fetchAnnouncesHomes.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAnnouncesHomes.fulfilled, (state, action) => {
        if(typeof action.payload === 'string') {
          console.log(action.payload)
        }else if(typeof action.payload === 'object'){
          state.isLoading = false;
          state.announcesHomes = action.payload;
        }
      })
      .addCase(fetchAnnouncesHomes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  }
});

/* 
  ADD IMPORTS
  ADD URL
  ADD INITIAL STATE
  ADD FUNCTIONS HERE
  THEN DEFINE SLICE
  THEN ADD REDUCERS ACTIONS
  AND THEN ADD THE CASES IN THE extraReducers
  AND THEN ADD SELECTORS
    SelectAll and other selectors
    Add other action creators specific to the home slice
  AND EXPORT REDUCER
*/

//export const { setHomes } = homesSlice.actions;



export const selectAllHomes = (state) => state.homes.homes;           //CHECK
export const selectMainHomes = (state) => state.homes.mainHomes;      //CHECK
export const selectPilar1Homes = (state) => state.homes.pilar1Homes;  //CHECK
export const selectPilar2Homes = (state) => state.homes.pilar2Homes;  //CHECK
export const selectPilar3Homes = (state) => state.homes.pilar3Homes;  //CHECK
export const selectAnnouncesHomes = (state) => state.homes.announcesHomes;  //CHECK

export const getItemsStatus = (state) => state.homes.status;
export const getItemsError = (state) => state.homes.error;

export const selectHomeById = (state, homeId) => {
  return state.homes.homes.find(home => home.id === homeId) 
}

export const { homeAdded, reactionAdded } = homesSlice.actions;

export default homesSlice.reducer;